import React from 'react';
import { Dropdown } from 'react-bootstrap';
import './DropDown.scss';

type Item = {
  label: string;
  value: any;
};

type Props = {
  items: Item[],
  value: any,
  onSelect: (item: Item) => void
};

const DropDown = (props: Props) => {
  const { items, onSelect, value } = props;
  const selected = items.find(i => i.value === value);
  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle variant="success" id="dropdown-basic">
          {selected?.label || 'Please select..'}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {items.map(item => <Dropdown.Item key={item.value} onClick={() => onSelect(item)}>{item.label}</Dropdown.Item>)}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default DropDown;
